var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConsole = function SvgConsole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.286 1h3.266A2.46 2.46 0 0 1 21 3.47v3.294c0 1.363-1.096 2.47-2.448 2.47h-3.266a2.46 2.46 0 0 1-2.45-2.47V3.47A2.46 2.46 0 0 1 15.287 1ZM3.449 1h3.265a2.46 2.46 0 0 1 2.45 2.47v3.294a2.46 2.46 0 0 1-2.45 2.47H3.45A2.46 2.46 0 0 1 1 6.764V3.47A2.46 2.46 0 0 1 3.449 1Zm0 11.766h3.265a2.46 2.46 0 0 1 2.45 2.47v3.294A2.46 2.46 0 0 1 6.713 21H3.45A2.46 2.46 0 0 1 1 18.53v-3.293a2.46 2.46 0 0 1 2.449-2.471Zm11.837 0h3.266c1.352 0 2.448 1.106 2.448 2.47v3.294A2.46 2.46 0 0 1 18.552 21h-3.266a2.46 2.46 0 0 1-2.45-2.47v-3.293a2.46 2.46 0 0 1 2.45-2.471Z",
    stroke: "#212121",
    strokeWidth: 1.4,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgConsole;